import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';

import { getManageContractsLink } from '../customerCenterTabService';

interface Props {
    closeDialog: () => void;
}

export const AssetOverviewGotoContractsDialog = (props: Props) => {
    const { closeDialog } = props;
    const navigate = useNavigate();
    const content = (
        <div>
            <div className='confirmationDialogText'>
                <FormattedMessage id={'intl-msg:marketplace.assetOverview.gotoManageContractsDisclaimer'} />{' '}
            </div>
        </div>
    );
    return (
        <ConfirmationDialog
            show={true}
            title={<FormattedMessage id='intl-msg:marketplace.assetOverview.gotoManageContracts.headline' />}
            content={content}
            onClickConfirm={() => navigate(getManageContractsLink())}
            onClickCancel={closeDialog}
            cancelButtonText={<FormattedMessage id={'intl-msg:marketplace.navigations.back'} />}
            confirmButtonText={<FormattedMessage id={'intl-msg:marketplace.myServices.manageContracts'} />}
        />
    );
};
